export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ekdETubDrz9wG1uDv16zRM/FORENSI_IT_PAGINA_1.jpg',
    alt: 'Copertina del Volume 1, Fondamenti di Scienze Forensi, con microscopio, lente di ingrandimento e scheda di impronte digitali',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jwEuByW9ujjcR1nxs7r8Hy/FORENSI_IT_PAGINA_2.jpg',
    alt: 'Pagina di esempio Le impronte digitali hanno insegnato a confrontare con metodo: i cinque passaggi del confronto delle impronte',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/coM7mNENEq6wAtNyjJCkBq/FORENSI_IT_PAGINA_3.jpg',
    alt: 'Pagina di esempio Tutto comincia dal sopralluogo: individuare, documentare, raccogliere, confezionare e conservare le prove',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/efYPTuy2YooR6VhtnTjRXU/FORENSI_IT_PAGINA_4.jpg',
    alt: 'Pagina di esempio Il tipo di prova decide il metodo: tabella dei tipi di prova fisica, biologica, chimica, traccia, documentale e digitale',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tAgXZBeGutjHaLJSPpKeDj/FORENSI_IT_PAGINA_5.jpg',
    alt: 'Pagina di esempio Lo stesso battistrada non significa la stessa scarpa: confronto ipotetico di impronte di scarpe',
  },
];
